import { z } from 'zod'

/**
 * Boolean URL coercion schema.
 *
 * URL search params are always strings, so z.boolean().safeParse('true') fails.
 * z.coerce.boolean() is also wrong — it does Boolean(string), making 'false' truthy.
 *
 * Use this schema when storing a boolean in a URL param via useSyncedState:
 *   useSyncedState('compare', boolUrl, 'url', false)
 */
export const boolUrl = z.enum(['true', 'false']).transform((v) => v === 'true')
